export default __webpack_public_path__ + "static/AGaramondPro-Bold-26b7f980032a65d843906ace0f977434.otf";